import { useContext, useEffect, useState } from "react";

import { TeethContextV1, TeethContextType, TeethSectionType } from "../indexv1";
import usePopup from "../../../../hooks/usePopup";


const TeethSection = ({ id }: { id: number }) => {


  const { showSnackbar } = usePopup()

  const [color1, setColor1] = useState('white');
  const [color2, setColor2] = useState('white');
  const [color3, setColor3] = useState('white');
  const [color4, setColor4] = useState('white');
  const [innerColor, setInnerColor] = useState('white');

  const { setSelectedTooth, selectedTooth, edit } = useContext(TeethContextV1) as TeethContextType


  useEffect(() => {

    setColor1("white");
    setColor2("white");
    setColor3("white");
    setColor4("white");
    setInnerColor("white");

    Object.entries(selectedTooth).map(([key]) => {

      if (selectedTooth[key]?.toothNo == id) {
        selectedTooth[key]?.section?.l1 == false ? setColor1("white") : setColor1("red")
        selectedTooth[key]?.section?.r1 == false ? setColor2("white") : setColor2("red")
        selectedTooth[key]?.section?.r2 == false ? setColor3("white") : setColor3("red")
        selectedTooth[key]?.section?.l2 == false ? setColor4("white") : setColor4("red")
        selectedTooth[key]?.section?.c == false ? setInnerColor("white") : setInnerColor("red")
      }
    })
  }, [selectedTooth, edit])

  const toggleColor = (slice: string, setColor: any, sectionCode: keyof TeethSectionType, id: number) => {
    if (selectedTooth[`teeth${id}`]) {
      setColor(slice === 'red' ? 'white' : 'red');
      setSelectedTooth((prev) => {
        const isSectionSelected = prev[`teeth${id}`]?.section[sectionCode];
        return {
          ...prev,
          [`teeth${id}`]: {
            ...prev[`teeth${id}`],
            section: {
              ...prev[`teeth${id}`]?.section,
              [sectionCode]: !isSectionSelected
            }
          }
        }
      })
    } else {
      showSnackbar({
        variant: "error",
        message: "select teeth first",
        open: true,
        duration: 2000,
      })
    }
  }



  return (
    <div className="pie-container">
      <div
        className="slice slice1"
        style={{ backgroundColor: color1 }}
        onClick={() => toggleColor(color1, setColor1, "l1", id)}
      ></div>
      <div
        className="slice slice2"
        style={{ backgroundColor: color2 }}
        onClick={() => toggleColor(color2, setColor2, "r1", id)}
      ></div>
      <div
        className="slice slice3"
        style={{ backgroundColor: color3 }}
        onClick={() => toggleColor(color3, setColor3, "r2", id)}
      ></div>
      <div
        className="slice slice4"
        style={{ backgroundColor: color4 }}
        onClick={() => toggleColor(color4, setColor4, "l2", id)}
      ></div>
      <div
        className="inner-pie"
        style={{ backgroundColor: innerColor }}
        onClick={() => toggleColor(innerColor, setInnerColor, "c", id)}
      ></div>
    </div>
  )
}

export default TeethSection


